import ServicesPresentation from "./ServicesPresentation";
import ServicesPresentationXS  from "./ServicesPresentationXS";

const initServicesPresentation = () => { 
  let servicesPresentation = document.getElementById('services-presentation');
  if (servicesPresentation) { 
    new ServicesPresentation(servicesPresentation);
  }

  let servicesPresentationXS = document.getElementById('services-presentation-xs');
  if (servicesPresentationXS) { 
    new ServicesPresentationXS(servicesPresentationXS);
  }
}

initServicesPresentation();


// WEBPACK FOOTER //
// ./ui/assets/js/ServicesPresentation/init.js